import type { TypedMyBrandSection } from './-MyBrandSection';
import RawMyBrandSection from './MyBrandSection.vue';
export * from './-MyBrandSection';
export const MyBrandSection = RawMyBrandSection as typeof TypedMyBrandSection;
